import { render } from "./AddControl.vue?vue&type=template&id=52ed4160&ts=true"
import script from "./AddControl.vue?vue&type=script&lang=ts"
export * from "./AddControl.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__